module.exports = __webpack_public_path__ + "pic/33.6c1620a6.png";